//@ts-nocheck
export default {
  TITLE: "title",
  HEADER: "header",
  PARAGRAPH: "paragraph",
  REPORT_DATE_GENERATE: "report_date_generate",
};
